<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="row justify-content-between align-items-center nav-big">
            <div class="col-xl-3 col-lg-3 col-md-3 col-12 nav-left">
                <a class="navbar-brand" href="/home">
                    <img src="https://static.cleanlive.cn/site/img/logo.png" alt="">
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>
            <div class="col-xl-9 col-12">
                <div class="collapse navbar-collapse nav-tab-content" id="navbarSupportedContent">
                    <ul class="nav nav-pills nav-tab">
                        <li class="nav-item" v-for="(item, index) in navList" :key="index">
                            <router-link :to="item.host" class="nav-link" :class="[item.host === $route.name ? 'active' : '']">{{item.text}}</router-link>
                        </li>
                    </ul>
                    <form class="form-inline">
                        <a href="https://waypal-student.cleanlive.cn/" target="_blank" class="nav-user">个人中心</a>
                    </form>
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      navNum: 0,
      navList: [
        { text: '首页', host: 'home' },
        { text: '精品课程', host: 'fineCourse' },
        { text: '课程体系', host: 'course' },
        { text: '教材体系', host: 'teaching' },
        { text: '外教师资', host: 'teacher' },
        { text: '教学平台', host: 'platform' },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/reset.less";
.nav-big {
  max-width: 1200px;
  margin: 0 auto;
}
.nav-left {
  display: flex;
  justify-content: space-between;
}
.nav-user {
  width: 130px;
  height: 42px;
  line-height: 40px;
  font-family: 'Microsoft YaHei';
  margin: 0 auto;
  text-align: center;
  color: rgba(254, 133, 0, 1) !important;
  border-radius: 8px;
  border: 1px solid rgba(254, 133, 0, 1);
  &:hover {
    background: linear-gradient(90deg, rgba(255, 184, 63, 1), rgba(254, 144, 0, 1));
    color: #fff !important;
  }
}
.nav-tab{
  margin-bottom: 0;
  li {
    font-size: 18px;
    font-family: 'Microsoft YaHei'
  } 
}

@media screen and (min-width: 1365px) {
  .nav-tab-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 415px) {
  .nav-tab{
    margin-bottom: 1rem;
    li {
      width: 100%;
      .nav-link {
        width: 100%;
      }
    }
  } 
}
</style>



// WEBPACK FOOTER //
// src/components/wayHeader.vue